import { FC, createContext, useContext } from 'react';
import { FeatureFlagsType } from '../constants/featureFlags';

interface IFeatureFlagsProviderProps {
  featureFlags: { [key in FeatureFlagsType]: boolean };
}

export const useFeatureFlags = (): { [key in FeatureFlagsType]: boolean } => {
  const context = useContext(FeatureFlagsContext);
  return context;
};

export const useFeatureFlag = (flag: FeatureFlagsType) => {
  const context = useContext(FeatureFlagsContext);
  return context[flag] === true;
};

export const FeatureFlag: FC<{ flag: FeatureFlagsType }> = ({
  flag,
  children,
}) => {
  const featureFlag = useFeatureFlag(flag);
  return featureFlag ? <>{children}</> : null;
};

export const FeatureFlagsContext = createContext<{
  [key in FeatureFlagsType]: boolean;
}>({} as any);

export const FeatureFlagsProvider: FC<IFeatureFlagsProviderProps> = ({
  featureFlags,
  children,
}) => {
  return (
    <FeatureFlagsContext.Provider value={featureFlags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};
